module.exports = __webpack_public_path__ + "static/mstile-150x150-c3ce58ca8f0c3a4f001ba6f44cde43ee.png";